import React from "react";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const AboutImg = "https://images.unsplash.com/photo-1515443423862-b79d32c1b8f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  const { content } = useContent();
  const s = content?.settings || {};

  return (
    <div data-testid="about-page">
      <PageHeader eyebrow="About" title="Part print house. Part agency. Part lab." intro={s.about_intro} />
      <section className="bg-[#FAFAFA] py-20 md:py-28 px-6 md:px-12 lg:px-16">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <Reveal className="md:col-span-5 md:sticky md:top-28">
            <div className="overflow-hidden">
              <img src={AboutImg} alt="TetraLab studio" className="w-full object-cover" />
            </div>
          </Reveal>
          <div className="md:col-span-6 md:col-start-7 space-y-16">
            {(s.chapters || []).map((c, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div data-testid={`about-chapter-${i}`} className="border-t border-black/15 pt-6">
                  <div className="flex items-baseline gap-6">
                    <span className="font-display text-6xl md:text-7xl tracking-tighter text-transparent" style={{ WebkitTextStroke: "1px #050505" }}>{c.number}</span>
                    <h2 className="font-display text-3xl md:text-4xl tracking-tight">{c.title}</h2>
                  </div>
                  <p className="text-zinc-600 text-lg leading-relaxed mt-5">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
